export default {"src":"/_next/static/image/public/images/loading_128.6a7246548cd99fd82b233e63c6aa5463.gif","height":128,"width":128};